import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import userService from "../services/user.service";

export const getVideoLiveFilter = createAsyncThunk(
    "video/liveFilter",
    async (queryParams, thunkAPI) => {
      try {
        const response = await userService.getVideoLiveFilter()
        thunkAPI.dispatch(setMessage(response.data))
        return response.data.details
      } catch (err) {
        thunkAPI.dispatch(setMessage(err.response));
        return thunkAPI.rejectWithValue(err.response.data);
      }
    }
  )
 
  const initialState = { liveFilter: [], isFetching: false, isFetched: false };

  const videoLiveFilterSlice = createSlice({
    name: "videoLiveFilter",
    initialState,
    extraReducers: {
      [getVideoLiveFilter.fulfilled]: (state, action) => {
       state.liveFilter = action.payload
       state.isFetching = false
       state.isFetched = true
      },
      [getVideoLiveFilter.rejected]: (state, action) => {
        state.isFetching = false;
        state.isFetched = false;
      }
    },
  });
  
  const { reducer } = videoLiveFilterSlice;
  export default reducer;